// :cow: Cosmose CONFIDENTIAL :iso:
export enum ExecutionTypes {
  mobile = 'mobile',
  LegalCensorship = 'legal-censorship',
  CreativeCensorship = 'creative-censorship',
  TrackingCodes = 'tracking-codes',
  AdPreview = 'ad-preview'
}

export enum ExecutionStatus {
  InReview = 'IN_REVIEW',
  New = 'NEW',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}
